export default __webpack_public_path__ + "static/media/smallTopbarIcon.2bafa202.svg";